import type { Product, ProductSearch, SearchDTO } from '../types/products'

export const useProductsService = () => {
  const config = useRuntimeConfig()
  const BASE_URL = `${config.public.apiBase}/api/products`

  return {
    getProduct(id: number) {
      return fetchJson<FetchResult<Product>>(
        'GET', `${BASE_URL}/${id}`,
      )
    },
    getProductsPromotions() {
      return fetchJson<FetchResult<ProductSearch[]>>(
        'GET', `${BASE_URL}/promotions`,
      )
    },
    fetchProducts(payload: SearchDTO) {
      return fetchJson<FetchResult<ProductSearch[]>, typeof payload>(
        'POST', `${BASE_URL}/search`, payload,
      )
    },
  }
}
